import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconShareDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" d="m13.218 3.86 8.407 6.7a1.002 1.002 0 0 1 0 1.561L13.21 18.84a1 1 0 0 1-1.62-.785v-3.389a9.14 9.14 0 0 0-8.132 6.33.517.517 0 0 1-.797.26.5.5 0 0 1-.186-.26 10.098 10.098 0 0 1 9.123-13.142V4.645a1 1 0 0 1 1.621-.784" /></svg></>;
}
IconShareDefault.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconShareDefault;